module.exports = __webpack_public_path__ + "img/shadow-portrait.53378a9.png";